//!!alias widgets/helpers/math

export function clamp(v, max, min) {
    var clamp_top = max===null?v:Math.min(v, max);
    var clamp_bottom = min===null?clamp_top:Math.max(clamp_top, min);
    return clamp_bottom;
}
